// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.assistant-content {
  display: block;
}
.assistant-content ::ng-deep a[href*="/channel-uploads/"]:not([href\$=".png"]):not([href\$=".jpg"]):not([href\$=".jpeg"]):not([href\$=".gif"]):not([href\$=".webp"]),
.assistant-content ::ng-deep a[href*="/uploads/"]:not([href\$=".png"]):not([href\$=".jpg"]):not([href\$=".jpeg"]):not([href\$=".gif"]):not([href\$=".webp"]) {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  background: rgba(100, 140, 255, 0.1);
  border: 1px solid rgba(100, 140, 255, 0.2);
  color: inherit;
  text-decoration: none;
  font-size: 0.9em;
  transition: background 0.15s ease, border-color 0.15s ease;
  margin: 4px 0;
}
.assistant-content ::ng-deep a[href*="/channel-uploads/"]:not([href\$=".png"]):not([href\$=".jpg"]):not([href\$=".jpeg"]):not([href\$=".gif"]):not([href\$=".webp"])::before,
.assistant-content ::ng-deep a[href*="/uploads/"]:not([href\$=".png"]):not([href\$=".jpg"]):not([href\$=".jpeg"]):not([href\$=".gif"]):not([href\$=".webp"])::before {
  content: "\\e226";
  font-family: "Material Icons";
  font-size: 16px;
  opacity: 0.7;
}
.assistant-content ::ng-deep a[href*="/channel-uploads/"]:not([href\$=".png"]):not([href\$=".jpg"]):not([href\$=".jpeg"]):not([href\$=".gif"]):not([href\$=".webp"]):hover,
.assistant-content ::ng-deep a[href*="/uploads/"]:not([href\$=".png"]):not([href\$=".jpg"]):not([href\$=".jpeg"]):not([href\$=".gif"]):not([href\$=".webp"]):hover {
  background: rgba(100, 140, 255, 0.18);
  border-color: rgba(100, 140, 255, 0.35);
  text-decoration: none;
}
.assistant-content ::ng-deep blockquote {
  margin: 12px 0;
  padding: 6px 14px;
  border-left: 3px solid rgba(128, 128, 128, 0.3);
  color: rgba(0, 0, 0, 0.5);
  font-size: 0.85em;
}
.assistant-content ::ng-deep blockquote p {
  margin: 0;
}

:host-context(.dark) .assistant-content ::ng-deep blockquote {
  color: rgba(255, 255, 255, 0.45);
  border-left-color: rgba(255, 255, 255, 0.2);
}

.thinking-content {
  display: block;
  border-left: 2px solid rgba(128, 128, 128, 0.2);
  padding: 10px;
  padding-left: 12px;
  margin-bottom: 15px !important;
  margin-top: 15px !important;
}

:host-context(.dark) .thinking-content {
  border-left-color: rgba(255, 255, 255, 0.12);
}

.thinking-indicator {
  padding: 6px 0;
  font-size: 0.85em;
  color: rgba(128, 128, 128, 0.7);
  animation: thinking-pulse 2s ease-in-out infinite;
}

:host-context(.dark) .thinking-indicator {
  color: rgba(200, 200, 200, 0.5);
}

.thinking-indicator.narration {
  animation: none;
  display: flex;
  gap: 8px;
  padding: 4px 0;
  color: rgba(128, 128, 128, 0.85);
}
.thinking-indicator.narration::before {
  content: "●";
  flex: none;
  font-size: 0.8em;
  line-height: 1.7;
}

:host-context(.dark) .thinking-indicator.narration {
  color: rgba(200, 200, 200, 0.6);
}

@keyframes thinking-pulse {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}
.tool-message {
  margin: 8px 0;
}

.tool-call {
  background: rgba(128, 128, 128, 0.1);
  border: 1px solid rgba(128, 128, 128, 0.2);
  border-radius: 6px;
  overflow: hidden;
}
.tool-call.open {
  background: rgba(128, 128, 128, 0.15);
}

.tool-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.12s ease;
  min-width: 0;
}
.tool-summary:hover {
  background: rgba(128, 128, 128, 0.15);
}

.tool-icon {
  flex-shrink: 0;
  width: 20px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--tool-accent, #1976d2);
}
.tool-icon ::ng-deep svg {
  width: 16px;
  height: 16px;
}

.tool-name {
  font-weight: 600;
  font-size: 13px;
  color: inherit;
}

.tool-param-preview {
  flex: 1;
  min-width: 0;
  opacity: 0.6;
  font-size: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tool-expand-icon {
  margin-left: auto;
  opacity: 0.5;
  transition: transform 0.2s ease;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
}
.tool-expand-icon.rotated {
  transform: rotate(90deg);
}
.tool-expand-icon svg {
  width: 14px;
  height: 14px;
}

.tool-details {
  padding: 12px;
  border-top: 1px solid rgba(128, 128, 128, 0.2);
  font-size: 12px;
  background: rgba(128, 128, 128, 0.05);
}

.tool-params-section {
  margin-bottom: 12px;
}
.tool-params-section strong {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
}

.tool-param {
  padding: 4px 8px;
  margin: 3px 0;
  background: rgba(128, 128, 128, 0.08);
  border: 1px solid rgba(128, 128, 128, 0.15);
  border-radius: 4px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
}

.param-key {
  color: var(--tool-accent, #1976d2);
  font-weight: 600;
  margin-right: 6px;
}

.param-value {
  word-break: break-word;
}

.tool-result-section {
  padding-top: 8px;
}
.tool-result-section strong {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
}

.tool-result-content {
  font-size: 11px;
}
.tool-result-content pre {
  margin: 0;
  padding: 10px;
  background: rgba(128, 128, 128, 0.1);
  color: inherit;
  border: 1px solid rgba(128, 128, 128, 0.2);
  border-left: 3px solid var(--tool-accent, rgba(25, 118, 210, 0.5));
  border-radius: 4px;
  overflow-x: auto;
  overflow-y: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: "Ubuntu Mono", ui-monospace, "SF Mono", Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  max-height: 300px;
}
.tool-result-content em {
  font-style: italic;
  opacity: 0.5;
}

.tool-group {
  margin: 4px 0;
  border: 1px solid rgba(128, 128, 128, 0.2);
  border-radius: 6px;
  overflow: hidden;
}

.tool-group-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: rgba(128, 128, 128, 0.07);
  transition: background 0.12s ease;
}
.tool-group-header:hover {
  background: rgba(128, 128, 128, 0.13);
}

.tool-group-icons {
  display: flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
}

.tool-group-icon {
  display: flex;
  align-items: center;
  opacity: 0.65;
  color: var(--tool-accent, #1976d2);
}
.tool-group-icon ::ng-deep svg {
  width: 14px;
  height: 14px;
}

.tool-group-label {
  flex: 1;
  min-width: 40%;
  font-size: 12px;
  opacity: 0.65;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tool-group-label.working {
  font-style: italic;
}

.tool-group-more {
  font-size: 11px;
  line-height: 14px;
  padding: 0 5px;
  border-radius: 8px;
  opacity: 0.7;
  background: rgba(128, 128, 128, 0.18);
  flex-shrink: 0;
}

.working-spinner {
  flex-shrink: 0;
}

.tool-group-toggle {
  flex-shrink: 0;
  opacity: 0.4;
  display: flex;
  align-items: center;
  transition: transform 0.2s ease;
}
.tool-group-toggle.open {
  transform: rotate(90deg);
}
.tool-group-toggle svg {
  width: 14px;
  height: 14px;
}

.tool-group-body {
  border-top: 1px solid rgba(128, 128, 128, 0.15);
}
.tool-group-body .tool-call {
  border-radius: 0;
  border: none;
  border-bottom: 1px solid rgba(128, 128, 128, 0.1);
}
.tool-group-body .tool-call:last-child {
  border-bottom: none;
}

.ask-user-question {
  margin: 12px 0;
  padding: 16px;
  background: rgba(128, 128, 128, 0.08);
  border: 1px solid rgba(128, 128, 128, 0.2);
  border-left: 3px solid var(--tool-accent, #1976d2);
  border-radius: 6px;
}
.ask-user-question .ask-question-header {
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 4px;
}
.ask-user-question .ask-question-context {
  margin: 0 0 10px;
  padding: 8px 10px;
  font-family: "JetBrains Mono", "Fira Code", ui-monospace, monospace;
  font-size: 12px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
  background: rgba(128, 128, 128, 0.12);
  border-radius: 4px;
}
.ask-user-question .ask-question-text {
  font-size: 14px;
  margin-bottom: 12px;
}
.ask-user-question .ask-question-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ask-user-question .ask-option {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  background: rgba(128, 128, 128, 0.06);
  border: 1px solid rgba(128, 128, 128, 0.15);
  border-radius: 6px;
  cursor: default;
}
.ask-user-question .ask-option .option-label {
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
}
.ask-user-question .ask-option .option-description {
  font-size: 12px;
  opacity: 0.75;
}
.ask-user-question .ask-option.clickable {
  cursor: pointer;
  transition: background 0.12s, border-color 0.12s;
}
.ask-user-question .ask-option.clickable:hover {
  background: rgba(25, 118, 210, 0.1);
  border-color: rgba(25, 118, 210, 0.45);
}
.ask-user-question .ask-option.selected {
  background: rgba(25, 118, 210, 0.14);
  border-color: rgba(25, 118, 210, 0.65);
}
.ask-user-question .ask-option.dimmed {
  opacity: 0.45;
}

.file-path-btn {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: inherit;
  opacity: 0.8;
  font: inherit;
  cursor: pointer;
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 2px;
}
.file-path-btn:hover {
  opacity: 1;
  color: var(--tool-accent, #1976d2);
  text-decoration-style: solid;
}

.tool-group-files {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
  font-size: 12px;
  font-family: var(--font-mono, monospace);
}

.tool-group-file {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

.streaming-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 0;
}
.streaming-indicator .dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: currentColor;
  opacity: 0.4;
  animation: dot-pulse 1.5s ease-in-out infinite;
}
.streaming-indicator .dot:nth-child(1) {
  animation-delay: 0s;
}
.streaming-indicator .dot:nth-child(2) {
  animation-delay: 0.3s;
}
.streaming-indicator .dot:nth-child(3) {
  animation-delay: 0.6s;
}

@keyframes dot-pulse {
  0%, 60%, 100% {
    transform: scale(1);
    opacity: 0.4;
  }
  30% {
    transform: scale(1.5);
    opacity: 0.8;
  }
}
@media (max-width: 768px) {
  :host {
    max-width: 100%;
    overflow: hidden;
  }
  .tool-message {
    max-width: 100%;
    overflow: hidden;
  }
  .tool-call {
    max-width: 100%;
  }
  .tool-summary {
    flex-wrap: nowrap;
    min-width: 0;
    max-width: 100%;
  }
  .tool-param-preview {
    min-width: 0;
    max-width: 40%;
  }
  .tool-name {
    flex-shrink: 0;
  }
  .tool-details {
    max-width: 100%;
    overflow-x: auto;
  }
  .tool-param {
    word-break: break-all;
    overflow-wrap: anywhere;
  }
  .tool-result-content pre {
    max-width: 100%;
    font-size: 10px;
  }
}
:host-context(.dark) {
  --tool-accent: #42a5f5;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tool-message/tool-message.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB;EACE,cAAA;AADF;AAIE;;EAEE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;EACA,0CAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,0DAAA;EACA,aAAA;AAFJ;AAII;;EACE,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,YAAA;AADN;AAII;;EACE,qCAAA;EACA,uCAAA;EACA,qBAAA;AADN;AAME;EACE,cAAA;EACA,iBAAA;EACA,+CAAA;EACA,yBAAA;EACA,iBAAA;AAJJ;AAMI;EAAI,SAAA;AAHR;;AAOA;EACE,gCAAA;EACA,2CAAA;AAJF;;AAQA;EACE,cAAA;EACA,+CAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,2BAAA;AALF;;AAQA;EACE,4CAAA;AALF;;AAQA;EACE,cAAA;EACA,iBAAA;EACA,+BAAA;EACA,iDAAA;AALF;;AAQA;EACE,+BAAA;AALF;;AAQA;EACE,eAAA;EACA,aAAA;EACA,QAAA;EACA,cAAA;EACA,gCAAA;AALF;AAME;EACE,YAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AAJJ;;AAQA;EACE,+BAAA;AALF;;AAQA;EACE;IAAW,YAAA;EAJX;EAKA;IAAM,UAAA;EAFN;AACF;AAIA;EACE,aAAA;AAFF;;AAKA;EACE,oCAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;AAFF;AAIE;EACE,qCAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,iCAAA;EACA,YAAA;AAHF;AAKE;EACE,qCAAA;AAHJ;;AAOA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;AAJF;AAME;EACE,WAAA;EACA,YAAA;AAJJ;;AAQA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AALF;;AAQA;EACE,OAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,6EAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AALF;;AAQA;EACE,iBAAA;EACA,YAAA;EACA,+BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AALF;AAOE;EACE,wBAAA;AALJ;AAQE;EACE,WAAA;EACA,YAAA;AANJ;;AAUA;EACE,aAAA;EACA,8CAAA;EACA,eAAA;EACA,qCAAA;AAPF;;AAUA;EACE,mBAAA;AAPF;AASE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AAPJ;;AAWA;EACE,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,2CAAA;EACA,kBAAA;EACA,6EAAA;EACA,eAAA;AARF;;AAWA;EACE,kCAAA;EACA,gBAAA;EACA,iBAAA;AARF;;AAWA;EACE,sBAAA;AARF;;AAWA;EACE,gBAAA;AARF;AAUE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AARJ;;AAYA;EACE,eAAA;AATF;AAWE;EACE,SAAA;EACA,aAAA;EACA,oCAAA;EACA,cAAA;EACA,0CAAA;EACA,kEAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,uFAAA;EACA,eAAA;EACA,iBAAA;AATJ;AAYE;EACE,kBAAA;EACA,YAAA;AAVJ;;AAeA;EACE,aAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qCAAA;EACA,iCAAA;AAZF;AAcE;EACE,qCAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,kCAAA;AAbF;AAeE;EACE,WAAA;EACA,YAAA;AAbJ;;AAiBA;EACE,OAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAdF;AAgBE;EACE,kBAAA;AAdJ;;AAkBA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,qCAAA;EACA,cAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;AAfF;AAiBE;EACE,wBAAA;AAfJ;AAkBE;EACE,WAAA;EACA,YAAA;AAhBJ;;AAoBA;EACE,+CAAA;AAjBF;AAmBE;EACE,gBAAA;EACA,YAAA;EACA,iDAAA;AAjBJ;AAmBI;EACE,mBAAA;AAjBN;;AAuBA;EACE,cAAA;EACA,aAAA;EACA,qCAAA;EACA,0CAAA;EACA,kDAAA;EACA,kBAAA;AApBF;AAsBE;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;AApBJ;AAuBE;EACE,gBAAA;EACA,iBAAA;EACA,mEAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qCAAA;EACA,kBAAA;AArBJ;AAwBE;EACE,eAAA;EACA,mBAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAvBJ;AA0BE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,qCAAA;EACA,2CAAA;EACA,kBAAA;EACA,eAAA;AAxBJ;AA0BI;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AAxBN;AA2BI;EACE,eAAA;EACA,aAAA;AAzBN;AA6BI;EACE,eAAA;EACA,gDAAA;AA3BN;AA6BM;EACE,mCAAA;EACA,sCAAA;AA3BR;AAgCI;EACE,oCAAA;EACA,sCAAA;AA9BN;AAkCI;EACE,aAAA;AAhCN;;AAwCA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,0BAAA;EACA,6BAAA;EACA,0BAAA;AArCF;AAuCE;EACE,UAAA;EACA,kCAAA;EACA,4BAAA;AArCJ;;AA0CA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,wCAAA;AAvCF;;AAyCA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAtCF;;AA0CA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAvCF;AAyCE;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,8CAAA;AAvCJ;AAyCI;EAAiB,mBAAA;AAtCrB;AAuCI;EAAiB,qBAAA;AApCrB;AAqCI;EAAiB,qBAAA;AAlCrB;;AAsCA;EACE;IACE,mBAAA;IACA,YAAA;EAnCF;EAqCA;IACE,qBAAA;IACA,YAAA;EAnCF;AACF;AAuCA;EACE;IACE,eAAA;IACA,gBAAA;EArCF;EAwCA;IACE,eAAA;IACA,gBAAA;EAtCF;EAyCA;IACE,eAAA;EAvCF;EA0CA;IACE,iBAAA;IACA,YAAA;IACA,eAAA;EAxCF;EA2CA;IACE,YAAA;IACA,cAAA;EAzCF;EA4CA;IACE,cAAA;EA1CF;EA6CA;IACE,eAAA;IACA,gBAAA;EA3CF;EA8CA;IACE,qBAAA;IACA,uBAAA;EA5CF;EA+CA;IACE,eAAA;IACA,eAAA;EA7CF;AACF;AAiDA;EACE,sBAAA;AA/CF","sourcesContent":["// Tool message styles\n// Uses opacity-based colors that adapt to any theme (light, dark, custom)\n\n.assistant-content {\n  display: block;\n\n  // File attachment links — styled as visible chips (exclude image extensions)\n  ::ng-deep a[href*=\"/channel-uploads/\"]:not([href$=\".png\"]):not([href$=\".jpg\"]):not([href$=\".jpeg\"]):not([href$=\".gif\"]):not([href$=\".webp\"]),\n  ::ng-deep a[href*=\"/uploads/\"]:not([href$=\".png\"]):not([href$=\".jpg\"]):not([href$=\".jpeg\"]):not([href$=\".gif\"]):not([href$=\".webp\"]) {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    border-radius: 8px;\n    background: rgba(100, 140, 255, 0.1);\n    border: 1px solid rgba(100, 140, 255, 0.2);\n    color: inherit;\n    text-decoration: none;\n    font-size: 0.9em;\n    transition: background 0.15s ease, border-color 0.15s ease;\n    margin: 4px 0;\n\n    &::before {\n      content: '\\e226';\n      font-family: 'Material Icons';\n      font-size: 16px;\n      opacity: 0.7;\n    }\n\n    &:hover {\n      background: rgba(100, 140, 255, 0.18);\n      border-color: rgba(100, 140, 255, 0.35);\n      text-decoration: none;\n    }\n  }\n\n  // Blockquote styling (used for system notices like compaction)\n  ::ng-deep blockquote {\n    margin: 12px 0;\n    padding: 6px 14px;\n    border-left: 3px solid rgba(128, 128, 128, 0.3);\n    color: rgba(0, 0, 0, 0.5);\n    font-size: 0.85em;\n\n    p { margin: 0; }\n  }\n}\n\n:host-context(.dark) .assistant-content ::ng-deep blockquote {\n  color: rgba(255, 255, 255, 0.45);\n  border-left-color: rgba(255, 255, 255, 0.2);\n}\n\n// Thinking content — subtle left border to distinguish from regular content\n.thinking-content {\n  display: block;\n  border-left: 2px solid rgba(128, 128, 128, 0.2);\n  padding: 10px;\n  padding-left: 12px;\n  margin-bottom: 15px !important;\n  margin-top: 15px !important;\n}\n\n:host-context(.dark) .thinking-content {\n  border-left-color: rgba(255, 255, 255, 0.12);\n}\n\n.thinking-indicator {\n  padding: 6px 0;\n  font-size: 0.85em;\n  color: rgba(128, 128, 128, 0.7);\n  animation: thinking-pulse 2s ease-in-out infinite;\n}\n\n:host-context(.dark) .thinking-indicator {\n  color: rgba(200, 200, 200, 0.5);\n}\n\n.thinking-indicator.narration {\n  animation: none;\n  display: flex;\n  gap: 8px;\n  padding: 4px 0;\n  color: rgba(128, 128, 128, 0.85);\n  &::before {\n    content: '●';\n    flex: none;\n    font-size: 0.8em;\n    line-height: 1.7;\n  }\n}\n\n:host-context(.dark) .thinking-indicator.narration {\n  color: rgba(200, 200, 200, 0.6);\n}\n\n@keyframes thinking-pulse {\n  0%, 100% { opacity: 0.5; }\n  50% { opacity: 1; }\n}\n\n.tool-message {\n  margin: 8px 0;\n}\n\n.tool-call {\n  background: rgba(128, 128, 128, 0.1);\n  border: 1px solid rgba(128, 128, 128, 0.2);\n  border-radius: 6px;\n  overflow: hidden;\n\n  &.open {\n    background: rgba(128, 128, 128, 0.15);\n  }\n}\n\n.tool-summary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.12s ease;\n  min-width: 0;\n\n  &:hover {\n    background: rgba(128, 128, 128, 0.15);\n  }\n}\n\n.tool-icon {\n  flex-shrink: 0;\n  width: 20px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--tool-accent, #1976d2);\n\n  ::ng-deep svg {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.tool-name {\n  font-weight: 600;\n  font-size: 13px;\n  color: inherit;\n}\n\n.tool-param-preview {\n  flex: 1;\n  min-width: 0;\n  opacity: 0.6;\n  font-size: 12px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tool-expand-icon {\n  margin-left: auto;\n  opacity: 0.5;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 14px;\n  height: 14px;\n\n  &.rotated {\n    transform: rotate(90deg);\n  }\n\n  svg {\n    width: 14px;\n    height: 14px;\n  }\n}\n\n.tool-details {\n  padding: 12px;\n  border-top: 1px solid rgba(128, 128, 128, 0.2);\n  font-size: 12px;\n  background: rgba(128, 128, 128, 0.05);\n}\n\n.tool-params-section {\n  margin-bottom: 12px;\n\n  strong {\n    display: block;\n    margin-bottom: 6px;\n    font-size: 12px;\n  }\n}\n\n.tool-param {\n  padding: 4px 8px;\n  margin: 3px 0;\n  background: rgba(128, 128, 128, 0.08);\n  border: 1px solid rgba(128, 128, 128, 0.15);\n  border-radius: 4px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 11px;\n}\n\n.param-key {\n  color: var(--tool-accent, #1976d2);\n  font-weight: 600;\n  margin-right: 6px;\n}\n\n.param-value {\n  word-break: break-word;\n}\n\n.tool-result-section {\n  padding-top: 8px;\n\n  strong {\n    display: block;\n    margin-bottom: 6px;\n    font-size: 12px;\n  }\n}\n\n.tool-result-content {\n  font-size: 11px;\n\n  pre {\n    margin: 0;\n    padding: 10px;\n    background: rgba(128, 128, 128, 0.1);\n    color: inherit;\n    border: 1px solid rgba(128, 128, 128, 0.2);\n    border-left: 3px solid var(--tool-accent, rgba(25, 118, 210, 0.5));\n    border-radius: 4px;\n    overflow-x: auto;\n    overflow-y: auto;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    font-family: 'Ubuntu Mono', ui-monospace, 'SF Mono', Menlo, Monaco, Consolas, monospace;\n    font-size: 12px;\n    max-height: 300px;\n  }\n\n  em {\n    font-style: italic;\n    opacity: 0.5;\n  }\n}\n\n// Tool group — Replit-style collapsed container for consecutive tool calls\n.tool-group {\n  margin: 4px 0;\n  border: 1px solid rgba(128, 128, 128, 0.2);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.tool-group-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 10px;\n  cursor: pointer;\n  user-select: none;\n  background: rgba(128, 128, 128, 0.07);\n  transition: background 0.12s ease;\n\n  &:hover {\n    background: rgba(128, 128, 128, 0.13);\n  }\n}\n\n.tool-group-icons {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  flex-shrink: 0;\n}\n\n.tool-group-icon {\n  display: flex;\n  align-items: center;\n  opacity: 0.65;\n  color: var(--tool-accent, #1976d2);\n\n  ::ng-deep svg {\n    width: 14px;\n    height: 14px;\n  }\n}\n\n.tool-group-label {\n  flex: 1;\n  min-width: 40%;\n  font-size: 12px;\n  opacity: 0.65;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  &.working {\n    font-style: italic;\n  }\n}\n\n.tool-group-more {\n  font-size: 11px;\n  line-height: 14px;\n  padding: 0 5px;\n  border-radius: 8px;\n  opacity: 0.7;\n  background: rgba(128, 128, 128, 0.18);\n  flex-shrink: 0;\n}\n\n.working-spinner {\n  flex-shrink: 0;\n}\n\n.tool-group-toggle {\n  flex-shrink: 0;\n  opacity: 0.4;\n  display: flex;\n  align-items: center;\n  transition: transform 0.2s ease;\n\n  &.open {\n    transform: rotate(90deg);\n  }\n\n  svg {\n    width: 14px;\n    height: 14px;\n  }\n}\n\n.tool-group-body {\n  border-top: 1px solid rgba(128, 128, 128, 0.15);\n\n  .tool-call {\n    border-radius: 0;\n    border: none;\n    border-bottom: 1px solid rgba(128, 128, 128, 0.1);\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n}\n\n// AskUserQuestion — render as an interactive prompt, not a collapsed tool\n.ask-user-question {\n  margin: 12px 0;\n  padding: 16px;\n  background: rgba(128, 128, 128, 0.08);\n  border: 1px solid rgba(128, 128, 128, 0.2);\n  border-left: 3px solid var(--tool-accent, #1976d2);\n  border-radius: 6px;\n\n  .ask-question-header {\n    font-weight: 600;\n    font-size: 13px;\n    margin-bottom: 4px;\n  }\n\n  .ask-question-context {\n    margin: 0 0 10px;\n    padding: 8px 10px;\n    font-family: 'JetBrains Mono', 'Fira Code', ui-monospace, monospace;\n    font-size: 12px;\n    line-height: 1.45;\n    white-space: pre-wrap;\n    word-break: break-word;\n    background: rgba(128, 128, 128, 0.12);\n    border-radius: 4px;\n  }\n\n  .ask-question-text {\n    font-size: 14px;\n    margin-bottom: 12px;\n  }\n\n  .ask-question-options {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .ask-option {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    padding: 10px 12px;\n    background: rgba(128, 128, 128, 0.06);\n    border: 1px solid rgba(128, 128, 128, 0.15);\n    border-radius: 6px;\n    cursor: default;\n\n    .option-label {\n      font-weight: 600;\n      font-size: 13px;\n      white-space: nowrap;\n    }\n\n    .option-description {\n      font-size: 12px;\n      opacity: 0.75;\n    }\n\n    // Interactive AskUserQuestion (live turn): options are clickable buttons.\n    &.clickable {\n      cursor: pointer;\n      transition: background 0.12s, border-color 0.12s;\n\n      &:hover {\n        background: rgba(25, 118, 210, 0.10);\n        border-color: rgba(25, 118, 210, 0.45);\n      }\n    }\n\n    // The chosen option, after the user answers.\n    &.selected {\n      background: rgba(25, 118, 210, 0.14);\n      border-color: rgba(25, 118, 210, 0.65);\n    }\n\n    // Non-chosen options, dimmed once answered.\n    &.dimmed {\n      opacity: 0.45;\n    }\n  }\n}\n\n// Clickable file paths in tool results, params and the collapsed header.\n// A reference, not a control: inherits the text colour, dotted underline,\n// accent only on hover (Ben, 2026-09-22: \"more of an anchor than a button\").\n.file-path-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  color: inherit;\n  opacity: 0.8;\n  font: inherit;\n  cursor: pointer;\n  text-decoration: underline;\n  text-decoration-style: dotted;\n  text-underline-offset: 2px;\n\n  &:hover {\n    opacity: 1;\n    color: var(--tool-accent, #1976d2);\n    text-decoration-style: solid;\n  }\n}\n\n// Written/edited files on the collapsed group header\n.tool-group-files {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 1;\n  min-width: 0;\n  overflow: hidden;\n  font-size: 12px;\n  font-family: var(--font-mono, monospace);\n}\n.tool-group-file {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 220px;\n}\n\n// Streaming indicator\n.streaming-indicator {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 0;\n\n  .dot {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background-color: currentColor;\n    opacity: 0.4;\n    animation: dot-pulse 1.5s ease-in-out infinite;\n\n    &:nth-child(1) { animation-delay: 0s; }\n    &:nth-child(2) { animation-delay: 0.3s; }\n    &:nth-child(3) { animation-delay: 0.6s; }\n  }\n}\n\n@keyframes dot-pulse {\n  0%, 60%, 100% {\n    transform: scale(1);\n    opacity: 0.4;\n  }\n  30% {\n    transform: scale(1.5);\n    opacity: 0.8;\n  }\n}\n\n// Mobile responsive\n@media (max-width: 768px) {\n  :host {\n    max-width: 100%;\n    overflow: hidden;\n  }\n\n  .tool-message {\n    max-width: 100%;\n    overflow: hidden;\n  }\n\n  .tool-call {\n    max-width: 100%;\n  }\n\n  .tool-summary {\n    flex-wrap: nowrap;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .tool-param-preview {\n    min-width: 0;\n    max-width: 40%;\n  }\n\n  .tool-name {\n    flex-shrink: 0;\n  }\n\n  .tool-details {\n    max-width: 100%;\n    overflow-x: auto;\n  }\n\n  .tool-param {\n    word-break: break-all;\n    overflow-wrap: anywhere;\n  }\n\n  .tool-result-content pre {\n    max-width: 100%;\n    font-size: 10px;\n  }\n}\n\n// Dark mode — accent color adjustment\n:host-context(.dark) {\n  --tool-accent: #42a5f5;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
